<img src="assets/svgs-optimized-painted/streak.svg" alt="" />

<div>
    <p class="title">{{ 'dashboard.banner.streak.title' | translate: { days: days() } }}</p>
    <p class="subtitle">{{ 'dashboard.banner.streak.subtitle' | translate }}</p>
</div>
